module.exports = __webpack_public_path__ + "img/network-teams.cf98125c.png";